








import Vue, { PropType } from "vue";
import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { CashDistributionViewType } from "@/model/data/dashboard/CashDistributionViewType";

export default Vue.extend({
    props: {
        widget: Object as PropType<DashboardWidget>,
    },
    computed: {
        availableDistributionType() {
            return [
                {
                    value: CashDistributionViewType.DistributionCountAverage,
                    text: this.$t("dashboard.widget_cash_distribution.distribution_type.distribution_count_average"),
                },
                {
                    value: CashDistributionViewType.DistributionCountTotal,
                    text: this.$t("dashboard.widget_cash_distribution.distribution_type.distribution_count_total"),
                },
            ];
        },
    },
});
